import React, { memo, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import Sidebar from "../Layouts/Sidebar";
import Topbar from "./Topbar";
import Heading from "./Heading";
import Loader from "../Components/UI/Loader";
import useSocketContext from "../context/socketContext";
import ModalLayout from "../Components/Modal/CommonModal";

const Master = () => {
  const { isLoading } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.user);
  const { _socket } = useSocketContext();

  useEffect(() => {
    _socket.connect();
    _socket.emit("join-room", user?.user_id);

    return () => {
      _socket.emit("leave-room", user?.user_id);
      _socket.disconnect();
    };
  }, [_socket, user?.user_id]);

  return (
    <>
      <Topbar />
      <Sidebar />

      <section className="main-content">
        <Heading />
        <div className="card_table">
          <Outlet />
        </div>
      </section>
      <ModalLayout />
      {isLoading && <Loader />}
    </>
  );
};

export default Master;
